module.exports = __webpack_public_path__ + "img/cloud_live.56f43af5.png";